import _ from 'lodash'
import React, { useEffect } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import ReactTable from 'react-table'
import {
  Button,
  Card,
  Col,
  Container,
  Modal,
  Row,
  UncontrolledTooltip
} from 'reactstrap'

import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import PageTitle from 'components/Title/PageTitle'
import SearchForm from 'components/SearchForm'
import CustomPagination from 'components/Pagination'

import IndustriesHOC from './actions'
import IndustriesForm from './Form'

import Lang from 'Lang/General'

const Industries = props => {

  useEffect(() => {
    let tmpIndex = _.findIndex(props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Fair' })
    props.onChangeIndustriesHOC('subscribedPackage', tmpIndex > -1)
  }, [])

  useEffect(() => {
    props.getIndustries({
      page: 1,
      is_paginated: true,
      filter:{"client_id": props.data.selectCenterReducer.selectedCenter.center.client_id},
    })
    props.onChangeIndustriesHOC('defaultQuery', {
      filter:{"client_id": props.data.selectCenterReducer.selectedCenter.center.client_id},
      page: 1,
      is_paginated: true,
    })
  }, [])

  useEffect(() => {
    if (!props.showEditModal) {
      props.onChangeIndustriesHOC('selectedIndustries', {})
    }
  }, [props.showEditModal])

  const permissionHandle = (context) => {
    let tmp = _.find(props.data.roleReducer.role.platforms, { name: 'Aciso Cockpit' })
    let tmpModules = {}
    if (tmp) {
      tmpModules = _.find(tmp.modules, { name: 'Fair' })
      return props.subscribedPackage && tmpModules[context]
    }
  }

  const renderCreateIndustriesForm = () => (
    <Modal isOpen={props.showCreateIndustries} size='xl' >
      <IndustriesForm
        data={props.data}
        clientID={props.data.selectCenterReducer.selectedCenter.center.client_id}
        mode={'create'}
        onSubmit={props.createIndustries}
        onClose={() => props.onChangeIndustriesHOC('showCreateIndustries', false)}
      />
      {props.onLoadIndustry && <LoadingOverlay />}
    </Modal>
  )

  const renderUpdateIndustriesForm = () => (
    <Modal isOpen={props.showEditModal} size='xl' >
      <IndustriesForm
        mode={'edit'}
        clientID={props.data.selectCenterReducer.selectedCenter.center.client_id}
        selectedIndustries={props.selectedIndustries}
        data={props.data}
        onSubmit={props.updateIndustries}
        onClose={() => props.onChangeIndustriesHOC('showEditModal', false)}
      />
      {props.onLoadIndustry && <LoadingOverlay />}
    </Modal>
  )

  return (
    <>
      <PageTitle
        heading={Lang['INDUSTRIES'][props.data.languageReducer.userSettings.admin_panel_language]}
        icon="pe-7s-tools icon-gradient bg-happy-itmeo"
        buttons={[
          {
            buttonText: Lang['CREATE_INDUSTRIES'][props.data.languageReducer.userSettings.admin_panel_language],
            onClick: () => props.onChangeIndustriesHOC('showCreateIndustries', true),
            display: permissionHandle('is_create')
          }
        ]}
      />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}>
        <Container fluid>
          <Row>
            <Col md={12}>
              <SearchForm
                searchParams={props.searchParams}
                onChangeHOCState={props.onChangeIndustriesHOC}
                defaultQuery={props.defaultQuery}
                getListAPI={val => props.getIndustries({
                  ... val,
                  filter : {
                    ... val.filter,
                    "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id
                  }
                })}
              />
            </Col>
            <Col md={12}>
              <Card className='main-card mb-3 p-4' >
                <ReactTable
                  defaultPageSize={10}
                  showPagination={false}
                  NoDataComponent={() => <span></span>}
                  data={props.industries}
                  columns={[
                    {
                      Header: Lang['TITLE'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'title'
                    },
                    {
                      Header: Lang['STATUS'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'status'
                    },
                    {
                      Header: Lang['ACTIONS'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'id',
                      style: {
                        "justify-content": "center"
                      },
                      Cell: row => (
                        <>
                          {
                            permissionHandle('is_update') && (
                              <>
                                <Button
                                  className="mb-2 mr-2 mt-2 btn-icon btn-icon-only"
                                  color='primary'
                                  id={ `portal-user-${ row.original.id }-edit-btn` }
                                  onClick={() => {
                                    props.onChangeIndustriesHOC('selectedIndustries', row.original)
                                    props.onChangeIndustriesHOC('showEditModal', true)
                                  }} >
                                  <i className="pe-7s-pen btn-icon-wrapper" />
                                </Button>
                                <UncontrolledTooltip
                                  target={ `portal-user-${ row.original.id }-edit-btn` }
                                  placement="top">
                                  { Lang[ 'EDIT' ][props.data.languageReducer.userSettings.admin_panel_language ] }
                                </UncontrolledTooltip>
                                <Button
                                  className="mb-2 mt-2 btn-icon btn-icon-only"
                                  color={ !row.original.is_active ? 'success' : 'danger' }
                                  onClick={() => {
                                    props.updateIndustries({
                                      ...row.original,
                                      is_active: !row.original.is_active
                                    })
                                  }}>
                                  {Lang[ row.original.is_active ? 'ARCHIVE' : 'ACTIVE' ][props.data.languageReducer.userSettings.admin_panel_language]}
                                </Button>
                              </>
                            )
                          }
                        </>
                      )
                    }
                  ]}
                />
                <CustomPagination
                  meta={props.industriesMeta}
                  onChangePage={ val => props.getIndustries({
                    ... props.query,
                    page: val
                  })}
                />
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactCSSTransitionGroup>
      {renderCreateIndustriesForm()}
      {renderUpdateIndustriesForm()}
      {props.onLoadIndustry && <LoadingOverlay />}
    </>
  )
}

export default IndustriesHOC(Industries)
